import { TestimonyRowActions } from 'modules/cms/testimony/components/TestimonyRowActions';
import { CellType, HeadCell } from '@dfl/mui-admin-layout';
import { ITestimony } from 'modules/cms/testimony/interfaces';
import { TESTIMONY_PERMISSIONS } from 'modules/cms/testimony/constants/testimony.permissions';
import { AvatarNameCell } from 'modules/common/components/AvatarNameCell';
import TestimonyCommentCell from '../components/TestimonyCommentCell/TestimonyCommentCell';
import { TestimonyStatusPicker } from '../components/TestimonyStatusPicker';
import { TestimonyRateCell } from '../components/TestimonyRateCell';

export const testimonyNameColumn: HeadCell<ITestimony> = {
  field: 'personName',
  headerName: 'testimony:fields.name',
  disablePadding: false,
  renderCell: (name: string, data?: ITestimony) => <AvatarNameCell hideLink image={data?.image} name={name} />,
};

export const testimonyTitleColumn: HeadCell<ITestimony> = {
  field: 'title',
  headerName: 'testimony:fields.title',
};

export const testimonyCommentColumn: HeadCell<ITestimony> = {
  field: 'comment',
  headerName: 'testimony:fields.comment',
  renderCell: (comment: string) => <TestimonyCommentCell comment={comment} />,
};

export const testimonyStatusColumn: HeadCell<ITestimony> = {
  field: 'enabled',
  headerName: 'testimony:fields.status',
  renderCell: (enabled, data) => (
    <TestimonyStatusPicker value={enabled} id={data?._id as string} />
  ),
};

export const testimonyActionsColumn: HeadCell<ITestimony> = {
  field: 'actions',
  sortable: false,
  permissions: TESTIMONY_PERMISSIONS.TESTIMONY_WRITE,
  headerName: 'common:actions',
  disablePadding: true,
  component: TestimonyRowActions,
};

export const testimonyRateColumn: HeadCell<ITestimony> = {
  field: 'rate',
  headerName: 'testimony:fields.rate',
  component: TestimonyRateCell
};

export const createdATColumn: HeadCell<any> = {
  field: 'createdAt',
  type: CellType.DATE,
  headerName: 'common:createdAt',
};

export const testimonyColumns: Array<HeadCell<any>> = [
  testimonyNameColumn,
  testimonyTitleColumn,
  testimonyRateColumn,
  testimonyCommentColumn,
  testimonyStatusColumn,
  createdATColumn,
  testimonyActionsColumn,
];
